import { hooks } from "./hookactions"
export let SYSAudit = { hooks }
